import { fetchLiveReportById } from '../../predict/src/core/api/reporting/report-builder';
import { createNewTemplate } from '../../predict/src/core/api/reporting/report-templates';
import { getDataReferencesFromReport } from '../../predict/src/report-builder/utils-data';
import { globalFinancialRefs, actualForecastIds } from '../../predict/src/report-builder/constants';

import { createMutation } from '../utils/mutations';
import { reportTemplatesQueryKey } from '../queries/reportTemplates';
import { queryClient } from '../core/queryClient';

export interface CreateTemplateFromReportInput {
  name: string;
  reportId: string;
}

type CreateTemplateResult = Awaited<ReturnType<typeof createNewTemplate>>;

export const createTemplateFromReportMutation = (
  workspaceId: string,
  organisationId: string,
  isConsolidation: boolean
) =>
  createMutation<CreateTemplateFromReportInput, CreateTemplateResult>({
    mutationFn: async (input: CreateTemplateFromReportInput) => {
      const report = await fetchLiveReportById(workspaceId, organisationId, input.reportId, isConsolidation);

      return createNewTemplate(
        workspaceId,
        organisationId,
        {
          name: input.name,
          locale: report.locale,
          data: report.data,
          data_references: getDataReferencesFromReport(report, actualForecastIds, globalFinancialRefs),
          page_count: report.page_count,
          orientation: report.orientation
        },
        'workspace',
        isConsolidation
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: reportTemplatesQueryKey(organisationId, workspaceId, isConsolidation)
      });
    }
  });
